import { type ChangeEvent, type CompositionEvent, type MouseEvent } from 'react';

import { type InputFocusOptions } from '../ui/Input';

export function resolveOnChangeEvent<E extends HTMLInputElement | HTMLTextAreaElement>(
    target: E,
    e: ChangeEvent<E> | MouseEvent<HTMLElement, MouseEvent> | CompositionEvent<HTMLElement>,
    targetValue?: string
) {
    // when a click occur on the clear icon button
    if (e.type === 'click') {
        const currentTarget = target.cloneNode(true) as E;

        const event = Object.create(e, {
            target: { value: currentTarget },
            currentTarget: { value: currentTarget }
        });

        currentTarget.value = '';
        return event as ChangeEvent<E>;
    }

    // override the target value when a composition event occur
    if (targetValue !== undefined) {
        const event = Object.create(e, {
            target: { value: target },
            currentTarget: { value: target }
        });

        // eslint-disable-next-line no-param-reassign
        target.value = targetValue;
        return event as ChangeEvent<E>;
    }

    return e as ChangeEvent<E>;
}

export function triggerFocus(
    element?: HTMLInputElement | HTMLTextAreaElement,
    option?: InputFocusOptions
) {
    if (!element) return;
    element.focus(option);
    const { cursor } = option || {};
    if (cursor) {
        const len = element.value.length;

        switch (cursor) {
            case 'start':
                element.setSelectionRange(0, 0);
                break;

            case 'end':
                element.setSelectionRange(len, len);
                break;

            default:
                element.setSelectionRange(0, len);
        }
    }
}

export function fixControlledValue<T>(value: T) {
    if (typeof value === 'undefined' || value === null) {
        return '';
    }
    return String(value);
}
